import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { CantinaService } from 'src/app/_servizi/cantina.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

@Component({
  selector: 'app-dettaglio-tipovisita',
  templateUrl: './dettaglio-tipovisita.component.html',
  styleUrls: ['./dettaglio-tipovisita.component.css']
})
export class DettaglioTipovisitaComponent implements OnInit, OnChanges {

  @Input() tipovisita: any;
  @Input() codiceForm: any;
  @Input() codiceFormMaster: any;

  @Input() linguaCorrente: any;
  @Input() canBack: any;
  @Input() idx: any;
  @Input() cart: boolean;

  @Output() goBack = new EventEmitter<any>();
  @Output() lastStepClicked = new EventEmitter<any>();

  procedi = false;
  prenotazione = false;

  get colori() {
    return this.appoggioService.getColoriIframe();
  }

  constructor(
    private messageService: MessageServiceService,
    private cantineService: CantinaService,
    private appoggioService: AppoggioService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
  }

  checkRegalabile(tipovisita): boolean {
    let regalabile = true;
    if (tipovisita.regala === '1' && tipovisita.tiporegala === 'gg') {
      regalabile = true;
    } else if (tipovisita.regala === '1' && tipovisita.tiporegala === 'data') {
      const dataScadenza = moment(tipovisita.fineregala);
      if (dataScadenza.isAfter(moment(), 'day')) {
        regalabile = true;
      } else {
        regalabile = false;
      }
    } else {
      regalabile = false;
    }
    return regalabile;
  }

  goToRegaloCantineWine(tipovisita) {
    this.prenotazione = false;
    this.procedi = true;
    // window.open("https://www.cantine.wine/booking/it/" + tipovisita.modrewrite + '/regala-visita/' + tipovisita.id, "_blank");
  }

  goToRichiediCantineWine(tipovisita) {
    window.open("https://www.cantine.wine/booking/it/" + tipovisita.modrewrite + '/richiedivisita/' + tipovisita.id, "_blank");
  }

  chooseCostoMinimo(tipovisita) {
    return tipovisita.costoDefault;
  }

  emettiClick(tipovisitaId: number): void {
    if (this.cart) {
      this.procedi = true;
      const values = {
        id: tipovisitaId,
        idx: this.idx
      }
      this.prenotazione = true;
      this.lastStepClicked.emit(values);
    } else {
      this.procedi = false;
      this.messageService.sendClickMessage(this.codiceForm, tipovisitaId, this.linguaCorrente, 1, this.messageService.getIdCookie());
    }
  }

  tornaIndietro() {
    this.procedi = false;
    this.prenotazione = false;
    this.goBack.emit();
  }

}
